import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
const DEFAULT_DEBOUNCE_DELAY = 250;
export default class Debounce extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        delay: PropTypes.number,
        fn: PropTypes.func.isRequired,
    };
    static defaultProps = {
        delay: DEFAULT_DEBOUNCE_DELAY,
    };
    componentDidMount() {
        this.debouncedFn = _.debounce(this.wrappedFn, this.props.delay);
    }
    wrappedFn = (...args) => {
        this.props.fn(...args);
    };
    render() {
        return this.props.children ? this.props.children(this.debouncedFn) : null;
    }
}
//# sourceMappingURL=index.js.map